import { useAppSelector } from "@hypexone/uicore";
import React from "react";
import Button from "../shared/Button/Button";

interface PopupProps {
  message: string;
  onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ message, onClose }) => {
  const {langData} = useAppSelector((state) => state.cms);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg relative">
        {" "}
        {/* Parent container with relative positioning */}
        <p className="text-lg mb-12">{message}</p>{" "}
        {/* Text in its own block with bottom margin */}
        <Button
          className="absolute bottom-4 mt-4 right-4 bg-blue-500 text-white py-2 px-4 rounded"
          onClick={onClose}
        >
          {langData?.['close']}
        </Button>
      </div>
    </div>
  );
};

export default Popup;
